import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Posts from '../../components/posts/Posts'
import Searchbar from '../../components/searchbar/Searchbar'
import Tags from '../../components/tags/Tags'
import BottomNav from '../../components/bottomnav/BottomNav';
import Navbar from '../../components/navbar/Navbar'
import { useLocation } from 'react-router'
import './home.css'
import { useContext } from "react";
import { Context } from "../../context/Context";

function Home() {
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const {search} = useLocation();
    const [searchTerm, setSearchTerm] = useState("");
    const {user} = useContext(Context);  

    const api_uri = "https://mentorxfa.herokuapp.com/api/posts";   

    useEffect(() => {
        const fetchPosts = async() => {
            const res = await axios.get(api_uri + search);
            setPosts(res.data.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1));
            setIsLoading(false)  
        }
        fetchPosts()   
        return () => {
            setPosts([]);
            setIsLoading(false)
            setSearchTerm("")
          };
    }, [search]);
    return (
        <>
        <Navbar/> 
        <div className="home">
            <Searchbar term={(e) => {setSearchTerm(e.target.value)}}/>
            <Tags loading={isLoading} />
            <Posts loading={isLoading} posts={posts} searchTerm={searchTerm}/> 
        </div>
        {user &&  <BottomNav/>}
        </>
    )
}


export default Home
